export const normalizePartnerMappingStatus = (rawData = {}) => {
  if (!rawData || !rawData?.data) {
    return {
      ...rawData,
      date: undefined,
    }
  }
  const { mappindg_allowed: mappingAllowed } = rawData.data
  return {
    ...rawData,
    data: {
      mappingAllowed,
    },
  }
}
